import styled from 'styled-components';
import { Select, Menu, Dropdown, Divider } from 'antd';
import { DataHeading, DataValue, LinkTo } from '../../../commonStyles';

export const MenuDropDown = styled(Menu)`
  .ant-dropdown-menu-item a {
    color: #022737 !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: 14px !important;
    padding: 5px 12px !important;
    border-bottom: none !important;
  }
  & {
    .ant-dropdown-menu-item:hover,
    .ant-dropdown-menu-submenu-title {
      background-color: #f2f2f2 !important;
    }
    font-size: 14px !important;
    color: #022737 !important;
    top: 9px;
    right: -10px;
    padding: 0;
    width: 150px;
    :after,
    :before {
      bottom: 100%;
      left: 98%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    :after {
      border-color: rgba(242, 242, 242, 0);
      border-bottom-color: #ffffff;
      border-width: 5px;
      margin-left: -5px;
    }
    :before {
      border-color: rgba(242, 242, 242, 0);
      border-bottom-color: #f2f2f2;
      border-width: 6px;
      margin-left: -6px;
    }

    :after,
    :before {
      bottom: 100%;
      left: 93%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
  }
`;

// message 1 starts
export const MenuDropDownMSG = styled(Menu)`
  &&& {
    .ant-dropdown-menu-item:hover,
    .ant-dropdown-menu-submenu-title {
      background-color: #f2f2f2 !important;
    }
    .ant-dropdown .ant-dropdown-placement-bottomRight {
    }
    top: 5.4px;
    padding: 0;
    :after,
    :before {
      bottom: 100%;
      left: 98%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
    :after {
      border-color: rgba(242, 242, 242, 0);
      border-bottom-color: #ffffff;
      border-width: 5px;
      margin-left: -5px;
    }
    :before {
      border-color: rgba(242, 242, 242, 0);
      border-bottom-color: #f2f2f2;
      border-width: 6px;
      margin-left: -6px;
    }
    width: 100%;
    border: solid 1px red;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
    border: solid 1px #f2f2f2;
    background-color: #ffffff;
    margin: 0 auto;
  }
  @media only screen and (max-width: 990px) {
    &&& {
      .ant-dropdown-menu-item:hover,
      .ant-dropdown-menu-submenu-title {
        background-color: #f2f2f2 !important;
      }
      .ant-dropdown .ant-dropdown-placement-bottomRight {
      }
      top: 5.4px;
      padding: 0;
      :after,
      :before {
        bottom: 100%;
        left: 98%;
        border: solid transparent;
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }
      :after {
        border-color: rgba(242, 242, 242, 0);
        border-bottom-color: #ffffff;
        border-width: 5px;
        margin-left: -5px;
      }
      :before {
        border-color: rgba(242, 242, 242, 0);
        border-bottom-color: #f2f2f2;
        border-width: 6px;
        margin-left: -6px;
      }
      width: 100%;
      border: solid 1px red;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
      border: solid 1px #f2f2f2;
      background-color: #ffffff;
      margin: 0 auto;
    }
    @media only screen and (max-width: 576px) {
      &&& {
        .ant-dropdown-menu-item:hover,
        .ant-dropdown-menu-submenu-title {
          background-color: #f2f2f2 !important;
        }
        .ant-dropdown .ant-dropdown-placement-bottomRight {
        }
        top: 5.4px;
        padding: 0;
        :after,
        :before {
          bottom: 100%;
          left: 98%;
          border: solid transparent;
          content: ' ';
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
        }
        :after {
          border-color: rgba(242, 242, 242, 0);
          border-bottom-color: #ffffff;
          border-width: 5px;
          margin-left: -5px;
        }
        :before {
          border-color: rgba(242, 242, 242, 0);
          border-bottom-color: #f2f2f2;
          border-width: 6px;
          margin-left: -6px;
        }
        width: 100%;
        border: solid 1px red;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
        border: solid 1px #f2f2f2;
        background-color: #ffffff;
        margin: 0 auto;
      }
    }
  }
`;

// message 1 ends
export const TopHeaderBackground = styled.div`
  background: ${props => props.theme.fontColors.headingColor};
  height: 40px;
  color: ${props => props.theme.colors.white};
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 999;
  .ant-select-selection-selected-value {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    & div {
      margin: 0px 5px 0px 0px !important;
      font-size: ${props => props.theme.fontSize.tertiary};
      color: ${props => props.theme.colors.primary};
      @media only screen and (max-width: 373px) {
        margin: 2px 5px 0px 0px !important;
      }
    }
  }
`;

export const ElementContainer = styled.div`
  width: ${props => (props.backContain ? '630px' : '500px')};
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
  font-family: HelveticaNeue-Bold;
  font-size: ${props => props.theme.fontSize.secondary};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-style: normal;
  font-stretch: condensed;
  letter-spacing: 0.5px;
  @media only screen and (max-width: 991px) {
    width: 365px;
  }
  @media only screen and (max-width: 576px) {
    & > div:first-child {
      display: none;
    }
  }
`;

export const TopHeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const AssistanceContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.tertiary};
  line-height: ${props => props.theme.lineHeight.primary};
  cursor: pointer;
  font-weight: normal;
  @media only screen and (max-width: 991.92px) {
    display: none;
  }
`;

export const SelectContainer = styled(Select)`
  width: 246px;
  @media only screen and (max-width: 360px) {
    width: 180px !important;
  }
  .ant-select-arrow {
    right: -1px;
    margin-right: 20px;
  }
  .ant-select-arrow > i {
    padding-top: 2px;
    color: #022737;
  }
  .ant-select-selection--single {
    height: auto !important;
  }
  .ant-select-selection {
    border-radius: 15px;
  }
  .ant-select-selection__rendered {
    line-height: 21px;
    width: 189px;
    margin-left: 20px;
    font-size: 12px;
    @media only screen and (max-width: 768px) {
      width: auto;
    }
    @media only screen and (max-width: 991px) and (min-width: 769px) {
      width: 180px !important;
    }
  }
  &&& {
    .ant-select-selection-selected-value {
      @media only screen and (max-width: 360px) {
        width: 119px !important;
      }
      @media only screen and (max-width: 768px) and (min-width: 360px) {
        width: 179px !important;
      }
    }
  }
  @media only screen and (max-width: 991.92px) {
    width: 235px;
  }
`;
export const SelectOptionContainer = styled(Select.Option)`
  padding: 5px 0px 5px 5px !important;
`;

export const DropdownAmount = styled(DataHeading)`
  color: #007fab;
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: 0.5px;
  margin-top: 0px;

  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const DropdownAccountName = styled(DataValue)`
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 0px;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 2;
  }
`;
export const DropdownAccountID = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: 0px;
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const ProfileContainer = styled.div`
  position: relative;
`;

export const ProfileDropdownNew = styled(Dropdown)`
  .ant-dropdown-menu {
    @media only screen and (min-width: 1024px) {
      transform: translateX(-121px);
    }
  }
`;

export const ProfileDropdown = styled.div`
  width: 181px;
  box-shadow: 0 9px 10px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #f2f2f2;
  background-color: #ffffff;
  position: absolute;
  z-index: 1000 !important;
  text-align: center;
  right: -15px;
  margin-top: 9px;
  :after,
  :before {
    bottom: 100%;
    left: 86.5%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  :after {
    border-color: rgba(242, 242, 242, 0);
    border-bottom-color: #ffffff;
    border-width: 5px;
    margin-left: -5px;
  }
  :before {
    border-color: rgba(242, 242, 242, 0);
    border-bottom-color: #f2f2f2;
    border-width: 6px;
    margin-left: -6px;
  }
`;

export const DataValueNew = styled(DataValue)`
  white-space: normal !important;
`;

export const MsgLinkTo = styled(LinkTo)`
  font-size: 16px !important;
  line-height: 1.5;
  font-family: HelveticaNeue;
  margin-top: 5px;
`;

export const MessagingDiv = styled.div`
  max-height: 450px;
  width: 360px;
  overflow-y: auto;
  padding: 20px 22px;
  @media only screen and (max-width: 990px) {
    max-height: 450px;
    width: 360px;
    padding: 20px;
  }
  @media only screen and (max-width: 576px) {
    max-height: 540px;
    width: 360px;
    padding: 20px;
  }
  @media only screen and (max-width: 320px) {
    max-height: 360px;
    width: 294px;
    padding: 15px;
  }
`;

export const ViewAllUpdate = styled.div`
  text-align: center;
  padding: 20px;
  border-top: 1px solid #eaeaea;
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
`;
export const ParentList = styled.ul`
  list-style: none;
  padding: 0;
  text-overflow: ellipsis;
`;

export const HeadingChild = styled.li`
  font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.5px;
  color: #505050;
  text-overflow: ellipsis;
`;
export const BodyChild = styled.li`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 5px;
  color: #022737;
`;
export const MessageBody = styled(DataHeading)`
  white-space: nowrap;
  width: 210px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5px;
`;

export const DividerDiv = styled(Divider)`
  margin-top: 20px 0;
  @media only screen and (max-width: 576px) {
    margin-top: 15px 0;
  }
  @media only screen and (max-width: 320px) {
    margin-top: 10px 0;
  }
`;

export const NavMenuItem = styled(Menu.Item)`
  text-transform: capitalize !important;
  font-family: inherit !important;
  text-align: left !important;
`;

// Go back design
export const GoBack = styled.button`
  outline: none;
  background: #006778;
  color: #ffffff;
  font-size: ${props => props.theme.fontSize.tertiary};
  letter-spacing: 0.5;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  border: none;
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
`;
